<div class="app-input-autocomplete">
  <div class="form-field" style="width: 100%; max-width: 100%">
    <label *ngIf="label" class="app-label"
      >{{ label }}
      <ng-container *ngIf="isRequired">*</ng-container>
      <i
        style="padding-left: 5px"
        tooltipPosition="top"
        pTooltip="{{ tooltip }}"
        *ngIf="tooltip"
        class="fa-solid fa-circle-question text-link-color"
      ></i>
    </label>    
    <div class="app-input-autocomplete-field-wrapper">
      <p-autocomplete
      [formControl]="inputFormControl"
      [suggestions]="filteredOptions$ | async"
      optionLabel="text"
      optionValue="value"
      placeholder="Search"
      [showClear]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="34"
      />
<!--    <input
        class="app-input-autocomplete-input"
        type="text"

        nbInput
        [placeholder]="placeholder"
        [nbAutocomplete]="auto"
        [formControl]="inputFormControl"
        #autoInput
      />
      <p-button
      class="app-input-autocomplete-field-clear-button"
        nbSuffix
        style="background: transparent"
        *ngIf="inputFormControl.value"
        [variant]="'text'"
        severity="contrast"
        (click)="clearField()"
        type="button"
        [title]="'clear_search' | translation"
      >
        <i class="fa-thin fa-xmark"></i>
      </p-button>
    </div>


  <nb-autocomplete #auto (selectedChange)="updateWithSelection($event)">
    <nb-option
      style="overflow: auto;scrollbar-width: none; -ms-overflow-style: none;"
      *ngFor="let option of filteredOptions$ | async"
      [value]="option.value"
      >{{ option.text }}</nb-option
    >
  </nb-autocomplete>-->
</div>
